import React from "react";
import { useTranslation } from "react-i18next";

interface CheckoutStepsProps {
 currentStep: number;
 steps: { number: number; name: string }[];
}

export const CheckoutSteps: React.FC<CheckoutStepsProps> = ({ currentStep, steps }) => {
 const { t } = useTranslation();
 return (
  <div className="w-full mb-8">
   <div className="flex items-center justify-between">
    {steps.map((step, index) => (
     <React.Fragment key={`${step.name}-${step.number}-${index}`}>
      <div className="flex items-center">
       <div
        className={`flex items-center justify-center w-10 h-10 border-2 ${
         currentStep >= step.number
          ? "bg-blue-600 border-blue-600 text-white"
          : "bg-white border-gray-300 text-gray-500"
        }`}
       >
        {currentStep > step.number ? (
         <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
         >
          <path
           strokeLinecap="round"
           strokeLinejoin="round"
           strokeWidth={2}
           d="M5 13l4 4L19 7"
          />
         </svg>
        ) : (
         <span className="font-semibold">{step.number}</span>
        )}
       </div>
       <div className="ml-3 hidden md:block">
        <div
         className={`text-sm font-medium ${
          currentStep >= step.number ? "text-blue-600" : "text-gray-500"
         }`}
        >
         {t("checkout.step")}{step.number}
        </div>
        <div
         className={`text-xs ${
          currentStep >= step.number ? "text-gray-900" : "text-gray-400"
         }`}
        >
         {step.name}
        </div>
       </div>
      </div>
      {index < steps.length - 1 && (
       <div
        className={`flex-1 h-0.5 mx-4 ${
         currentStep > step.number ? "bg-blue-600" : "bg-gray-300"
        }`}
       />
      )}
     </React.Fragment>
    ))}
   </div>
  </div>
 );
};

